function showDiscountOffers(target_element, shop_id){

  console.log("shop_id:"+shop_id)
  $.ajax({
        url: 'https://dev.bloomandgrowgroup.com/index.php?route=bloom/discount/getDiscounts&shop_id='+shop_id,
        dataType:'json',
        type:'post',
        success:function(data)
        {
          console.log("data:", data);
          if (data.length > 0){
            $.each(data, function(i) {

              if (data[i].discount_type=="collection"){              
                $('.data-item').each(function(index, item) {
      
                  var item_id = $(item).attr("data-item-id");
                  var item_collection_handle = $(item).attr("data-item-collection-handle");


                  if (typeof item_collection_handle !== 'undefined') {


                    if (item_collection_handle.includes(data[i].collections[0].handle)===true){

                    var discount_value = "";
                    if (data[i].percentage > data[i].value){
                      discount_value = data[i].percentage+"%";
                    }else{
                      discount_value = "$"+data[i].value;
                    }
                    var discount_message = data[i].discount_desc ? data[i].discount_desc : data[i].discount_title

                    // show message in collection page
                    $(target_element + item_id).append('<span class="discount_box_collection bg">'+discount_message+'</span>');

                    // show message in cart page
                    $('tr.cart__row#'+item_id+' .discount-title').append('<span style="color:red;">'+discount_message+'</span>');
                    
                    }
                    
                     
                  } else {
            
                  }
      
                  
                });

              } // end collection


              if (data[i].discount_type=="volume"){

                const processedVariantsVolume = new Set();
                
                $('.data-item').each(function(index, item) {
  
                  var item_id = $(item).attr("data-item-id");
                  var variant_ids = JSON.stringify(data[i].variant_ids);

                  if (variant_ids.includes(item_id)===true && !processedVariantsVolume.has(item_id) ){

                    //alert("have volume");
                    
                    var discount_value = "";
                    if (data[i].percentage > data[i].value){
                      discount_value = data[i].percentage+"%";
                    }else{
                      discount_value = "$"+data[i].value;
                    }
                
                    var discount_message = data[i].discount_desc ? data[i].discount_desc : data[i].discount_title
                     $(target_element + item_id).append('<span class="discount_box_volume">' + discount_message+'</span>');

                    // show message in cart page
                    $('tr.cart__row#'+item_id+' .discount-title').append('<span style="color:red;">' + discount_message+'</span>');

                     processedVariantsVolume.add(item_id);
                    
                  }
                });
              } // end volume

               if (data[i].discount_type=="tags"){

                $('.data-item').each(function(index, item) {

                  var item_id = $(item).attr("data-item-id");
                  var tag = data[i].productTag;
                  var item_tags = $(item).attr("data-item-tags");
                
                  if (item_tags.includes(tag)===true){
                    var discount_value = "";
                    if (data[i].percentage > data[i].value){
                      discount_value = data[i].percentage+"%";
                    }else{
                      discount_value = "$"+data[i].value;
                    }
                    var discount_message = data[i].discount_desc ? data[i].discount_desc : data[i].discount_title
                    $(target_element + item_id).append('<span class="discount_box_tag" >' + discount_message+'</span>');
                  }
          
                });

              } // end tags


              
            if (data[i].discount_type=="free"){

              const processedVariants = new Set();
              const processedFreeVariants = new Set();
              
                $('.data-item').each(function(index, item) { // EACH


                  var current_variant_id = $(item).attr("data-item-id"); // assign if product page

                  let product_free_variant_ids = JSON.stringify(data[i].free_variant_ids);
                      product_free_variant_ids = product_free_variant_ids.replaceAll('"', '').replaceAll('gid://shopify/ProductVariant/', '');
                  
                  let product_variant_ids = JSON.stringify(data[i].variant_ids); // varian ids
                      product_variant_ids = product_variant_ids.replaceAll('"', '').replaceAll('gid://shopify/ProductVariant/', '');

                  
                 if (product_variant_ids.includes(current_variant_id) && !processedVariants.has(current_variant_id)){ // show only discounts which include the current variant

                    // display discount message first
                    var discount_message = data[i].discount_desc ? data[i].discount_desc : data[i].discount_title
                    var free_bgcolor = data[i].free_type == "product" ? "style='background-color:#FFAB8B'":"";

                   // add free item in collection per product
                    $(target_element + current_variant_id).append('<span class="discount_box_collection" '+free_bgcolor+'>'+discount_message+'</span>');


                    const $card = $(target_element + current_variant_id).closest('.product-card');
                    const cleanValue = product_free_variant_ids.replace(/[\[\]]/g, '');
                    $card.find('.free-variant-id').val(cleanValue);
                   
                    //$(target_element + current_variant_id +' form .free-variant-id').val('free-variant-id', product_free_variant_ids.replace(/[\[\]]/g, ''));

                    if (product_variant_ids.includes(current_variant_id) && !product_free_variant_ids.includes(current_variant_id)) {
                      // add message in cartpage
                      
                      $('tr.cart__row#'+current_variant_id+' .discount-title').append('<span style="color:red;">'+discount_message+'</span>');
                      $('tr.cart__row#'+current_variant_id+' .cart__qty-input').attr('free-product-vid', product_free_variant_ids.replace(/[\[\]]/g, ''));
                      $('tr.cart__row#'+current_variant_id+' .cart__qty-input').attr('free-break-value', data[i].quantity);

                    }

                    // if (product_free_variant_ids.includes(current_variant_id)) {
                    //   console.log("free");
                    //   $('tr.cart__row #'+current_variant_id+' .discount-title').append('<span style="color:red;">Free Gift</span>');
                    // }
  
                     // Store processed variant IDs
                     processedVariants.add(current_variant_id);


                   
                   // add hidden data if qty > 0 PRODUCT
                    if (data[i].free_type == "product" && data[i].product_qty > 0){

                      console.log("add free item 2 ");

                      if (product_variant_ids.includes(current_variant_id)===true){ // add to each product in collection
                        $(this).attr('product_free_qty', data[i].product_qty);
                        $(this).attr('product_free_variant_id', data[i].free_products[0].id.replace('gid://shopify/ProductVariant/',''));
                        $(this).attr('product_free_variant_title', data[i].free_products[0].title);
                        $(this).attr('product_free_variant_img_url', data[i].free_products[0].img_url);
                        $(this).attr('product_volume_break', data[i].volume_break);
                        $(this).attr('product_free_all', data[i].free_all);
                        $(this).attr('product_variant_ids', data[i].variant_ids);
                      }
                      
                       $('.free-items').append('<input type="hidden" value="no" id="free-product-valid">');
                       $('.free-items').append('<input type="hidden" id="product_variant_ids" value="'+product_variant_ids+'" />');
                       $('.free-items').append('<input type="hidden" id="product_free_qty" value="'+data[i].product_qty+'" />');
                       $('.free-items').append('<input type="hidden" id="product_volume_break" value="'+data[i].volume_break+'" />');
                       $('.free-items').append('<input type="hidden" id="product_free_all" value="'+data[i].free_all+'" />');

                      // add free items 
                      $('.free-items').append('<div class="free-items-title">You have a gift!</div>');
                      
                        data[i].free_products.forEach(function (product, index) {
                            $('.free-items').append('<div class="free-item-row"><div class="free_id"><input type="radio" name="free_variant_id" value="'+product.id.replace("gid://shopify/ProductVariant/", '')+'" '+(index==0 ? "checked":"") +' /></div><div class="photo"><img src="'+ product.img_url+'" width="80" /></div><div class="title">'+ product.title+'</div></div>')
                        });

                      // show free items if required qty is 1
                        if(data[i].product_qty==1){
                          $('.free-items').css("display", "block");
                          $('#free-product-valid').val("yes");
                        }
                      
                      }

                     if (data[i].free_type == "collection" && data[i].collection_qty > 0){

                       
                         $('.collection-free-items').append('<input type="hidden" id="collection_variant_ids" value="'+product_variant_ids+'" />');
                         $('.collection-free-items').append('<input type="hidden" id="collection_free_qty" value="'+data[i].collection_qty+'" />');
                         $('.collection-free-items').append('<input type="hidden" id="collection_volume_break" value="'+data[i].volume_break+'" />');

                         data[i].free_products.forEach(function (product, index) {
                            $('.collection-free-items').append('<div class="free-item-row"><div class="free_id"><input type="radio" name="free_variant_id" value="'+product.id.replace("gid://shopify/ProductVariant/", '')+'" '+(index==0 ? "checked":"") +' /></div><div class="photo"><img src="'+ product.img_url+'" width="80" /></div><div class="title">'+ product.title+'</div></div>')
                          });


                         if(data[i].collection_qty==1){
                            //$('.collection-free-items').css("display", "block");
                            $('#free-product-valid').val("yes");
                         }
                       
                     }
                   
                 }else{


                   if (product_free_variant_ids.includes(current_variant_id) && !processedFreeVariants.has(current_variant_id)){
                      $('tr.cart__row#'+current_variant_id+' .discount-title').append('<span style="color:red;">Free Gift</span>');
                    }

                   processedFreeVariants.add(current_variant_id);

                   
                 } 
                  // if current in variant_ids
                  
                }); // end each item

              // FOR COLLECTION
              // display discount when current collection handle is in discount
              var current_collection_handle = $('#collection_handle').val();
              data[i].collections.forEach(function (collection, index) {
                  if(collection.handle == current_collection_handle){

                      let collection_variant_ids = JSON.stringify(data[i].variant_ids); // variant ids
                      collection_variant_ids = collection_variant_ids.replaceAll('"', '');
         
                      if (data[i].free_type == "collection" && data[i].collection_qty > 0){
                         $('.collection-free-items').append('<input type="hidden" id="collection_variant_ids" value="'+collection_variant_ids+'" />');
                         $('.collection-free-items').append('<input type="hidden" id="collection_free_qty" value="'+data[i].collection_qty+'" />');
                         $('.collection-free-items').append('<input type="hidden" id="collection_volume_break" value="'+data[i].volume_break+'" />');
                        
                      }

                      data[i].free_products.forEach(function (product, index) {
                            $('.collection-free-items').append('<div class="free-item-row"><div class="free_id"><input type="radio" name="free_variant_id" value="'+product.id.replace("gid://shopify/ProductVariant/", '')+'" '+(index==0 ? "checked":"") +' /></div><div class="photo"><img src="'+ product.img_url+'" width="80" /></div><div class="title">'+ product.title+'</div></div>')
                        });
                    
                  }
              });

  

              } // end free type
              
            });
            
          } // if has data
          
        }
      });
}


function checkChartHasDiscount(shop_id){
  $.ajax({
    url: 'https://dev.bloomandgrowgroup.com/index.php?route=bloom/discount/getDiscounts&shop_id='+shop_id,
    dataType:'json',
    type:'get',
    success:function(data)
    {
      
    if (data.length > 0){
      
        $.each(data, function(i) {
          if (data[i].discount_type=="collection"){              
            $('.data-item').each(function(index, item) {

              var item_id = $(item).attr("data-item-id");
              var item_collection_handle = $(item).attr("data-item-collection-handle");
              if (item_collection_handle.includes(data[i].collections[0].handle)===true){
                $("#cart-offers .cart-forgotten").addClass("show");
                return false;
              }
            });
          } // end collection
          
          if (data[i].discount_type=="volume"){
            $('.data-item').each(function(index, item) {

              var item_id = $(item).attr("data-item-id");
              var variant_ids = JSON.stringify(data[i].variant_ids);
              if (variant_ids.includes(item_id)===true){
                $("#cart-offers .cart-forgotten").addClass("show");
                return false;
              }
            });
          } // end volume

        });
        
      } // if has data
      
    }
  });
}


// SHOW FREE ITEMS IF QUANTITY SELECTED IS VALID
var item_select = '.product-form__item .product-form__input--quantity';
var item_select_qty = $('.product-form__item .product-form__input--quantity').val();

$('.free-items').css("display", "none"); // initials do in css

$(item_select).on("change", function(){
  
   if($('#product_free_qty').length > 0) {

      var item_select_qty = $('.product-form__item .product-form__input--quantity').val();
      var product_free_qty = $('#product_free_qty').val();

          if (item_select_qty >= product_free_qty){
            $('.free-items').css("display", "block");
            $('#free-product-valid').val("yes");
          }else{
            $('.free-items').css("display", "none");
            $('#free-product-valid').val("no");
          }

   }
});


function addFreeGift(title, img_url, free_variant_id, qty){
  $('.cart-popup .free-item-wrap').remove();
  $('.cart-popup-item').after('<div class="free-item-wrap"><strong>GIFT ADDED TO CART!</strong><br /><div class="free-item-row"><span><img src="'+img_url+'"></span><span>'+title+'<span></div></div>');
    
    
        jQuery.post('/cart/add.js', {
          quantity: qty,
          id: free_variant_id
        });
        
}




